import { ReactNode } from "react";
import DesktopSidebar from "./DesktopSidebar";

export default function DesktopLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen bg-background">
      <DesktopSidebar />
      <main className="flex-1 min-w-0 px-8 py-6">
        {children}
      </main>
    </div>
  );
}
